import { useEffect, useState } from "react";
import api from "@/lib/api";

export const DeployStamp = () => {
  const [startedAt, setStartedAt] = useState(null);

  useEffect(() => {
    let active = true;
    api
      .get("/build-info")
      .then((res) => {
        if (active) setStartedAt(res.data?.started_at || null);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  if (!startedAt) return null;

  const d = new Date(startedAt);
  const label = d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });

  return (
    <div
      data-testid="deploy-stamp"
      title={`This build started at ${d.toString()}`}
      className="pointer-events-none fixed bottom-2 left-1/2 z-50 -translate-x-1/2 rounded-full border border-[#272a35] bg-[#0b0c10]/80 px-3 py-1 text-[10px] font-medium tracking-wide text-[#6b7280] backdrop-blur-sm"
    >
      Last deployed: {label}
    </div>
  );
};

export default DeployStamp;
